/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneCoverBox as ResolvedStandaloneCoverBox } from 'base/components/standalone/CoverBox';

export const CoverBox: typeof ResolvedStandaloneCoverBox = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneCoverBox {...props} />
    );
});

export type CoverBoxProps = PropsFromComponent<typeof CoverBox>;

/** @deprecated Use slot architecture instead */
export const CoverBoxWith = (extras: DynamicStandaloneExtras): typeof CoverBox => {
    return function CoverBox(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'CoverBox');
        return <ResolvedStandaloneCoverBox {...mergeProps({ options: { theme } }, props)} />;
    }
}